module.exports = {
	"versions": {
		"lodash": "4.17.4/dist",
		"react": "0.14.3",
		"pmrpc": "1.30.0",
		"tweenmax": "1.19.0",
		"santaIde": "1.83.0"
	},
	"packages": [
		"addPanelData",
		"addPanelDataConsts",
		"addPanelInfra",
		"addPanelSections",
		"advancedStylePanel",
		"backgroundPresets",
		"baseUI",
		"blog",
		"boxSlideshow",
		"columnsControls",
		"compPanels",
		"constants",
		"core",
		"customizeDesignDataPanel",
		"databaseEditor",
		"debugTools",
		"designPanel",
		"designPanelUtils",
		"editorEventRegistry",
		"editorHints",
		"firstTimeExperience",
		"firstTimePanelsComponents",
		"gfppData",
		"helpIds",
		"higherOrderComponents",
		"imageCrop",
		"mediaServices",
		"mobileEditor",
		"pagesMenu",
		"panelUtils",
		"panels",
		"platform",
		"platformPanels",
		"popups",
		"rEditor",
		"santaPreview",
		"savePublish",
		"shoutOut",
		"staticAssets",
		"styles",
		"superAppMenuInfra",
		"symbols",
		"testUtils",
		"textControls",
		"tpa",
		"tpaPanels",
		"uiAnimations",
		"uiConstants",
		"userPreferences",
		"util",
		"videoSearch",
		"wixBookings",
		"wixCode",
		"wixStore"
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/santa-main-r/src/main/options/editor.json
// module id = 17
// module chunks = 0